import { capitalizeOnlyFirstLetter } from 'shared/utils/stringUtils';

const beneficiaryDefaults = {
  'Affordable Housing': 'residents',
  'Arts and Culture': 'participants',
  'Basic Needs': 'recipients',
  'Civic Engagement, Advocacy, and Systems Change': 'participants',
  'Community and Neighborhood Revitalization': 'community members',
  'Community and School-Based Meal Programs': 'recipients',
  'Community Economic Development': 'participants',
  'Community Resiliency': 'residents',
  'Disaster Preparation': 'participants',
  'Disaster Response': 'recipients',
  'Diversity, Equity, Inclusion, and Accessibility': 'people',
  'Early Childhood Development': 'youth',
  'Economic Security': 'participants',
  'Education: K-12 Classroom': 'students',
  'Education: Out-of-School Programming': 'students',
  'Education: Post-secondary, Career Development': 'students',
  'Educational Access': 'students',
  'Educator Training': 'students',
  'Emergency Housing': 'clients',
  'Environmental Conservation': 'community members',
  'Food Distribution': 'recipients',
  'Gender Equity': 'women and girls',
  'Growing and Harvesting': 'community members',
  Health: 'people',
  'Health Education and Behavior Change': 'participants',
  'Health Systems, Policy, Advocacy, and Research': 'beneficiaries',
  'Human Rights': 'beneficiaries',
  'Positive Youth Development': 'youth',
  'Public Safety': 'community members',
  'Racial Justice': 'beneficiaries',
  'Recreation and Play': 'youth',
  'Recycling and Waste': 'community members',
  'Scholarships and Fellowships': 'students',
  'Small Business and Non-Profit Support': 'employees',
  'STEM Education: K-12 Classroom': 'students',
  'STEM Education: Out-of-School Programming': 'students',
  'STEM Education: Post-secondary, Career Development': 'students',
  'Sustainable Agriculture': 'community members',
  'Sustainable Business Practices': 'community members',
  'Transit and Mobility': 'community members',
  'Water Access, Sanitation, and Hygiene': 'people',
  'Wildlife Conservation': 'animals',
  'Workforce Development': 'participants',
  'Domestic Animal Welfare': 'animals',
};

export const getDefaultPrimaryBeneficiary = (
  impactModelName: string | undefined,
): string | undefined => {
  const result = impactModelName
    ? beneficiaryDefaults[impactModelName as keyof typeof beneficiaryDefaults]
    : undefined;
  return capitalizeOnlyFirstLetter(result);
};
